export enum EventType {
    USER_REGISTER = 'user_register',
    USER_LOGIN = 'user_login',
    USER_SEND_MESSAGE = 'user_send_message',
    USER_ADDED_TO_CUSTOMER_REGISTER = 'user_added_to_customer_register',
    CREATE_CUSTOMER_REGISTER = 'create_customer_register',
    SET_AUTO_PAYMENT = 'set_auto_payment',
    CHANGE_CUSTOMER_REGISTER_STATUS = 'change_customer_register_status',
    CUSTOMER_REGISTER_ADD_TEAMMEMBER = 'customer_register_add_teammember',
    USED_FIXED_VALUE_DISCOUNT = 'used_fixed_value_discount',
    SEND_DOWNLOAD_READY_MAIL = 'send_download_ready_mail',
    SEND_FIRST_INFO_MAIL = 'send_first_info_mail',
    SEND_TEAMNUMBER_REMINDER_MAIL = 'send_teamnumber_reminder_mail',
    SEND_TEAMMEMBER_REMINDER_MAIL = 'send_teammember_reminder_mail',
    SEND_PAYMENT_REMINDER_MAIL = 'send_payment_reminder_mail',
    SEND_WAITLIST_MAIL = 'send_waitlist_mail',
    SEND_MOVED_UP_WAITLIST_MAIL = 'send_moved_up_waitlist_mail',
    SEND_CANCELLED_MAIL = 'send_cancelled_mail',
    SEND_NEW_TEAMMEMBER_PAYMENT_MAIL = 'send_new_teammember_payment_mail',
    SEND_RALLY_REGISTER_CONFIRMATION_MAIL = 'send_rally_register_confirmation_mail',
    SEND_PASSWORD_RESET_MAIL = 'send_password_reset_mail',
    SEND_ADD_TEAMMEMBER_MAIL = 'send_add_teammember_mail',
    SEND_STATUS_UPDATE_MAIL = 'send_status_update_mail',
    PUT_ACTION = 'put_action',
    POST_ACTION = 'post_action',
    DELETE_ACTION = 'delete_action',
}
